import { createSelector } from 'reselect'

import { selectAppState } from 'src/core/store/selectors/selectAppState'

export const selectSimulation = createSelector([selectAppState], ({ simulation }) => simulation)
